import { useSearchParams } from 'react-router-dom'

/**
 * Lê e escreve o parâmetro de URL `?doc=` que identifica o arquivo aberto na gaveta
 * (FileDrawer). Compartilhado entre AreaContentPage (listagem unificada) e
 * AreaDirectFiles (arquivos soltos abaixo dos cards) para que deep-link e o botão
 * voltar do navegador se comportem igual nos dois modos de página, independente de
 * qual componente renderizou a gaveta.
 */
export function useSelectedDocParam(): {
  selectedDocId: string | null
  setSelectedDocId: (id: string | null) => void
} {
  const [urlParams, setUrlParams] = useSearchParams()

  const selectedDocId = urlParams.get('doc')
  const setSelectedDocId = (id: string | null) => {
    setUrlParams((prev) => {
      const next = new URLSearchParams(prev)
      if (id) next.set('doc', id)
      else next.delete('doc')
      return next
    }, { replace: true })
  }

  return { selectedDocId, setSelectedDocId }
}
